import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { useContext, useEffect, useState } from 'react'
import { WebSocketContext } from '../../Providers/WebSocket/WebSocketContext'
import { CondominiosContext } from '../../Providers/CondominiosContext/CondominiosContext'
import DisplayCaixaAgua from './DisplayCaixaAgua/DisplayCaixaAgua'
import { Typography } from '@mui/material'
import FigmaTable from '../FigmaTable/FigmaTable'
import moment from 'moment'

const CaixaAgua = () => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { activeCond } = useContext(CondominiosContext)

    const [dadosCaixaAgua, setDadosCaixaAgua] = useState(null)
    const [historicoCaixaAgua, setHistoricoCaixaAgua] = useState(null)

    const getInfoCaixaAgua = (msg) => {
        setDadosCaixaAgua(msg.data.caixaAgua.dados)
        setHistoricoCaixaAgua(msg.data.caixaAgua.historico)
    }

    addRoute('getInfoCaixaAgua', getInfoCaixaAgua)
    const attDados = () => {
        sendWs("getInfoCaixaAgua", { filtros: { id_central: activeCond.id_central } })
    }
    useEffect(() => {
        sendWs("getInfoCaixaAgua", { filtros: { id_central: activeCond.id_central } })
        const interval = setInterval(() => {
            attDados()
        }, 15000)
        return () => clearInterval(interval)
    }, [])

    const columns = [
        {
            name: 'Evento',
            cell: row => row.descricao ? `${row.descricao}` : "",
            style: {
                width: '35%'
            }
        },
        {
            name: 'Nome Caixa',
            cell: row => row.nome ? `${row.nome}` : "",
            style: {
                width: '35%'
            }
        },
        {
            name: 'Data',
            cell: row => row.data ? moment(row.data).utc().format("DD/MM/YY HH:mm:ss", "UTC-3") : "",
            // cell: row => row.dt_criacao ? row.dt_criacao.split(' ')[1] : "",
            style: {
                width: '30%'
            }
        }
    ]

    return (
        <Grid container
            sx={{
                height: '100%',
                width: '100%',
                backgroundColor: '#D9D9D9',
                borderRadius: '5px',
                padding: '5px',
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                justifyContent: 'center',
                overflow: 'hidden'
            }}
            gap={0.5}
        >{dadosCaixaAgua && dadosCaixaAgua.length > 0
                ? <>
                    {dadosCaixaAgua
                        ? (<Grid item sx={{ width: '100%', height: '60%', overflow: 'auto', border: '1px solid black', borderRadius: '5px' }}>
                            {dadosCaixaAgua.map((item, index) => {
                                return (
                                    <DisplayCaixaAgua key={index} dados={item} />
                                )
                            })}
                        </Grid>)
                        : (<Grid item sx={{ width: '100%', height: '70%', overflow: 'auto', border: '1px solid black', borderRadius: '5px' }}>
                            <Typography fontSize="26px" fontWeight="600" textAlign="center">Sem Dados</Typography>
                        </Grid>)
                    }
                    {historicoCaixaAgua &&
            <Grid container sx={{ height: '40%' }}>
                <Typography fontSize="13px" fontWeight="600" textAlign="center">Histórico Últimos 15 Eventos</Typography>
                <Grid container sx={{ height: '80%', width: '100%', paddingBottom: '10px' }}>
                    <FigmaTable
                        data={historicoCaixaAgua}
                        columns={columns}
                    />
                </Grid>
            </Grid>
                    }
                </>
                : <Typography fontSize="16px" fontWeight="600" textAlign="center">Sem dados de caixa de água para exibir</Typography>}
        </Grid>
    )
}

export default CaixaAgua
